/**
 * Utilidades para sugerencia IA — Informe Evaluacion y Plan.
 */

const CAMPOS_RAIZ = [
  "motivoMenor",
  "motivoAcompanante",
  "motivoReferido",
  "perfilOcupacional",
  "objetivo",
  "organizacionComportamiento",
  "sensorial",
  "comunicacion",
  "evaluaciones",
  "impresionOcupacional",
  "objetivosTrimestre",
  "recomendaciones",
];

const GRUPOS = {
  abvd: ["alimentacion", "vestido", "controlEsfinter", "higiene", "descansoSueno"],
  aivdBase: ["tareasCasa", "pantallas"],
  aivdEscolar: ["dinero", "cuidadoOtros", "tiempoPlanificacion", "transporte"],
  motor: ["gruesas", "finas", "observacionesPosturales", "lateralidad"],
  cognitivo: [
    "percepcionVisual",
    "funcionesEjecutivas",
    "atencion",
    "memoria",
    "procesamientoEspacial",
  ],
};

const ETIQUETAS = {
  motivoMenor: "Motivo — nombre del menor",
  motivoAcompanante: "Motivo — acompañante",
  motivoReferido: "Motivo — referido por",
  perfilOcupacional: "Perfil ocupacional",
  objetivo: "Objetivo",
  organizacionComportamiento: "Organización del comportamiento",
  alimentacion: "Alimentación",
  vestido: "Vestido",
  controlEsfinter: "Control de esfínter",
  higiene: "Higiene personal",
  descansoSueno: "Descanso y sueño",
  tareasCasa: "Tareas en casa",
  pantallas: "Uso de pantallas",
  dinero: "Manejo de dinero",
  cuidadoOtros: "Cuidado de otros",
  tiempoPlanificacion: "Tiempo y planificación",
  transporte: "Transporte",
  gruesas: "Motricidad gruesa",
  finas: "Motricidad fina",
  observacionesPosturales: "Observaciones posturales",
  lateralidad: "Lateralidad",
  percepcionVisual: "Percepción visual",
  funcionesEjecutivas: "Funciones ejecutivas",
  atencion: "Atención y concentración",
  memoria: "Memoria",
  procesamientoEspacial: "Procesamiento espacial",
  sensorial: "Procesamiento sensorial",
  comunicacion: "Comunicación e interacción",
  evaluaciones: "Evaluaciones y resultados",
  impresionOcupacional: "Impresión ocupacional",
  objetivosTrimestre: "Objetivos del trimestre",
  recomendaciones: "Recomendaciones",
};

export function mergeAyudaEnDatosPlan(datosActuales, sugerencia, escolar) {
  const out = {
    ...datosActuales,
    datosGenerales: { ...(datosActuales.datosGenerales || {}) },
    abvd: { ...(datosActuales.abvd || {}) },
    aivd: { ...(datosActuales.aivd || {}) },
    motor: { ...(datosActuales.motor || {}) },
    cognitivo: { ...(datosActuales.cognitivo || {}) },
  };
  if (!sugerencia) return out;

  CAMPOS_RAIZ.forEach((k) => {
    const v = sugerencia[k];
    if (v != null && String(v).trim() !== "") {
      out[k] = String(v).trim();
    }
  });

  GRUPOS.abvd.forEach((k) => {
    const v = sugerencia.abvd && sugerencia.abvd[k];
    if (v != null && String(v).trim() !== "") {
      out.abvd[k] = String(v).trim();
    }
  });

  const aivdKeys = escolar
    ? [...GRUPOS.aivdBase, ...GRUPOS.aivdEscolar]
    : GRUPOS.aivdBase;
  aivdKeys.forEach((k) => {
    const v = sugerencia.aivd && sugerencia.aivd[k];
    if (v != null && String(v).trim() !== "") {
      out.aivd[k] = String(v).trim();
    }
  });

  GRUPOS.motor.forEach((k) => {
    const v = sugerencia.motor && sugerencia.motor[k];
    if (v != null && String(v).trim() !== "") {
      out.motor[k] = String(v).trim();
    }
  });

  GRUPOS.cognitivo.forEach((k) => {
    const v = sugerencia.cognitivo && sugerencia.cognitivo[k];
    if (v != null && String(v).trim() !== "") {
      out.cognitivo[k] = String(v).trim();
    }
  });

  return out;
}

export function listaVistaPreviaAyuda(sugerencia, escolar) {
  const items = [];
  if (!sugerencia) return items;

  const push = (label, valor) => {
    const t = String(valor || "").trim();
    if (t) items.push({ label, valor: t });
  };

  CAMPOS_RAIZ.forEach((k) => push(ETIQUETAS[k] || k, sugerencia[k]));

  GRUPOS.abvd.forEach((k) =>
    push(ETIQUETAS[k] || k, sugerencia.abvd && sugerencia.abvd[k])
  );

  const aivdKeys = escolar
    ? [...GRUPOS.aivdBase, ...GRUPOS.aivdEscolar]
    : GRUPOS.aivdBase;
  aivdKeys.forEach((k) =>
    push(ETIQUETAS[k] || k, sugerencia.aivd && sugerencia.aivd[k])
  );

  GRUPOS.motor.forEach((k) =>
    push(ETIQUETAS[k] || k, sugerencia.motor && sugerencia.motor[k])
  );

  GRUPOS.cognitivo.forEach((k) =>
    push(ETIQUETAS[k] || k, sugerencia.cognitivo && sugerencia.cognitivo[k])
  );

  return items;
}

export function contextoPacienteParaAyuda(datos, nombrePaciente, formato) {
  const dg = datos.datosGenerales || {};
  return [
    "Paciente: " + (nombrePaciente || dg.nombreApellido || ""),
    "Formato informe: " + (formato === "ESCOLAR" ? "Escolar" : "Infantil"),
    "Edad: " + (dg.edadTexto || dg.edad || ""),
    "Diagnostico conocido: " + (dg.diagnostico || "(no indicado)"),
    "Inicio terapia: " + (dg.fechaInicioTerapia || ""),
  ].join("\n");
}
